import React, { memo } from 'react'
import i18n from 'atpjs/helpers/i18n'
import { OPENING_TIMES } from 'tve/config/other'
import { parseTimeString } from 'tve/helpers/date'

const t = i18n.prefix(['components', 'openingTimes'])

const OpeningTimes = memo(() => (
  <div className="atp-grid">
    <div className="atp-grid-2-1 atp-grid-m-1-1">
      <span className="atp-bold">{t(['weekdays'])}</span>
      <br />
      {t(['openFromTo'], {
        start: parseTimeString(OPENING_TIMES.weekdays.start),
        end: parseTimeString(OPENING_TIMES.weekdays.end)
      })}
    </div>
    <div className="atp-grid-2-1 atp-grid-m-1-1">
      <span className="atp-bold">{t(['weekends'])}</span>
      <br />
      {t(['openFromTo'], {
        start: parseTimeString(OPENING_TIMES.weekends.start),
        end: parseTimeString(OPENING_TIMES.weekends.end)
      })}
    </div>
  </div>
))

OpeningTimes.displayName = 'OpeningTimes'

export default OpeningTimes
